import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(  private meta: Meta ) {

     
    this.meta.updateTag({ name: 'title', content: 'Fornituralternativa.com | Affidati ai nostri professionisti, il risparmio ti aspetta' });
    this.meta.updateTag({ name:'description', content:'Sei stanco di essere un numero? Non Ti senti Valorizzato dai fornitori che gestiscono le tue Utenze? Fornituralternativa.com | Affidati ai nostri professionisti, il risparmio ti aspetta   '});
    this.meta.updateTag({ name: 'keywords', content: 'Abolizione Mercato Tutelato , Mercato efwfwef libero' });


  }
  
  ngOnInit() {
   

  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts